<app-enfaf-modal
  heightButton="41px"
  title="Clonar curso: {{ courseName }}"
  svgIcon="copy"
  (onClose)="confirmCloseModal()"
  (onConfirm)="cloneCourse()"
  [disableConfirmButton]="courseForm.invalid || isSavingCourse"
  [isLoading]="isSavingCourse"
>
  <div content style="width: 100%">
    <form [formGroup]="courseForm" autocomplete="off">
      @if (isMaster) {
        <!-- ENF-2372 (E-9): the clone of a Máster is a new Máster; the server names it «{masterName} - 1ª Edición». -->
        <enfaf-input
          className="modal-input"
          color="light"
          data-testid="cloneMasterName"
          [control]="nameFC"
          [label]="'COURSE.EDITION.MASTER_NAME_LABEL' | translate"
          name="masterName"
          [placeholder]="'COURSE.EDITION.MASTER_NAME_LABEL' | translate"
          autocomplete="off"
          [maxlength]="masterNameMaxLengthAttr"
          [errorLabel]="masterNameErrorLabel"
          [description]="masterNameHint"
          type="text"
        >
        </enfaf-input>
      } @else {
        <enfaf-input
          className="modal-input"
          color="light"
          [control]="courseForm.controls['name']"
          label="Nombre del nuevo curso"
          name="courseName"
          placeholder="Nombre del nuevo curso"
          autocomplete="off"
          errorLabel="Nombre del nuevo curso requerido"
          type="text"
        >
        </enfaf-input>
      }
    </form>
  </div>
</app-enfaf-modal>
